module.exports = __webpack_public_path__ + "static/media/data_science.00167fa5.png";